module.exports = {

    resources: {
        reporttemplates: {
            name: 'Report Templates',
            fields: {
                createdate: 'Created',
                createdby: 'Created By',
                lastupdate: 'Last Update',
                updatedby: 'Updated By'
            },
        }
    }
}
